// services/country.service.ts

import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { eps } from './url.service'
import { User } from '../store/auth/auth.state'
import { environment } from '../../environments/environment'
export interface UserBirthday {
  id: string
  name: string
  avatar: string
  department: string
  dateOfBirth: string
}

export interface MonthlyBirthdayResponse {
  type: 'monthly'
  today: UserBirthday[]
  tomorrow: UserBirthday[]
  upcoming: UserBirthday[]
}

export interface AllBirthdayResponse {
  type: 'all'
  total: number
  page: number
  limit: number
  data: UserBirthday[]
}

export type BirthdayResponse = MonthlyBirthdayResponse | AllBirthdayResponse

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = eps.user.userApi
  constructor(private http: HttpClient) {}

  getUsers(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/all`)
  }

  getEmployees(params?: string | null, page?: number, limit?: number): Observable<any> {
    const url = params
      ? `${this.apiUrl}?${params}&page=${page}&limit=${limit}`
      : `${this.apiUrl}?page=${page}&limit=${limit}`
    return this.http.get<any>(url)
  }

  blockEmployee(id: string, status: boolean): Observable<any> {
    return this.http.put(`${this.apiUrl}/block/${id}`, { disabled: status })
  }

  deleteEmployee(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, {})
  }

  createEmployee(formData: FormData): Observable<any> {
    return this.http.post(`${this.apiUrl}`, formData)
  }

  getEmployeeById(id: string): Observable<User> {
    return this.http.get<User>(`${this.apiUrl}/${id}`)
  }

  getEmployeeByIdSubscription(id: string): Observable<User> {
    return this.http.get<User>(`${this.apiUrl}/subscription/${id}`)
  }

  portalAccessEmployee(id: string, portalAccess: boolean): Observable<any> {
    return this.http.put(`${this.apiUrl}/portalAccess/${id}`, { portalAccess: portalAccess })
  }
  // updateEmployee(user: {
  //   id: string
  //   // businessName: string
  //   // picture: string | null
  //   // website: string
  //   // address: string
  //   // cityId: number
  //   // zipCode: string
  //   // referenceIdFacebook: string
  //   // referenceIdInstagram: string
  //   // referenceIdLinkedIn: string
  //   // referenceIdTwitter: string
  //   // referenceIdWhatsapp: string,
  //   emergencyContact: string | object | null
  // }): Observable<User> {
  //   const formData = new FormData()
  //   // formData.append('businessName', business.businessName)
  //   if (user.emergencyContact) {
  //     const contact =
  //       typeof user.emergencyContact === 'string'
  //         ? user.emergencyContact
  //         : JSON.stringify(user.emergencyContact)
  //     formData.append('emergencyContact', contact)
  //   }

  //   // Append the picture if available
  //   // if (business.picture) {
  //   //   formData.append('picture', business.picture)
  //   // }

  //   // Include other necessary fields as FormData entries
  //   // if (business.address) formData.append('address', business.address)
  //   // if (business.cityId) formData.append('cityId', `${business.cityId}`) // or other appropriate format
  //   // if (business.zipCode) formData.append('zipCode', business.zipCode)
  //   // if (business.referenceIdFacebook) {
  //   //   formData.append('referenceIdFacebook', business.referenceIdFacebook)
  //   // }
  //   // if (business.referenceIdInstagram) {
  //   //   formData.append('referenceIdInstagram', business.referenceIdInstagram)
  //   // }
  //   // if (business.referenceIdLinkedIn) {
  //   //   formData.append('referenceIdLinkedIn', business.referenceIdLinkedIn)
  //   // }
  //   // if (business.referenceIdTwitter) {
  //   //   formData.append('referenceIdTwitter', business.referenceIdTwitter)
  //   // }
  //   // if (business.referenceIdWhatsapp) {
  //   //   formData.append('referenceIdWhatsapp', business.referenceIdWhatsapp)
  //   // }

  //   return this.http.put<User>(`${this.apiUrl}/${user.id}`, formData)
  // }

  updateEmployee(user: { id: string; data: FormData }): Observable<User> {
    return this.http.put<User>(`${this.apiUrl}/${user.id}`, user.data)
  }

  getUser(id: string): Observable<User> {
    return this.http.get<User>(`${this.apiUrl}/${id}`)
  }

  assignManager(payload: any) {
    // return this.http.post('/employee-manager/assign', payload)
    return this.http.post(`${environment.apiBaseUrl}/employee-manager/assign`, payload)
  }

  getAssignManager(employeeId: any) {
    // return this.http.post('/employee-manager/assign', payload)
    return this.http.get<any>(`${environment.apiBaseUrl}/employee-manager/employee/${employeeId}`)
  }

  // getTeamMembersOfEmployee(employeeId: any, search?: string, page?: number, limit?: number) {
  //   // return this.http.post('/employee-manager/assign', payload)
  //   const url = search
  //     ? `${environment.apiBaseUrl}/employee-manager/team-members/${employeeId}?page=${page}&limit=${limit}&search=${search}`
  //     : `${environment.apiBaseUrl}/employee-manager/team-members/${employeeId}?page=${page}&limit=${limit}`
  //   // return this.http.get<any>(
  //   //   `${environment.apiBaseUrl}/employee-manager/team-members/${employeeId}`
  //   // )
  //   return this.http.get<any>(url)
  // }

  getTeamMembersOfEmployee(employeeId: any, search?: string | null, page?: number, limit?: number) {
    const url = `${environment.apiBaseUrl}/employee-manager/team-members/${employeeId}?page=${page}&limit=${limit}&search=${search}`
    return this.http.get<any>(url)
  }

  getTeamMemberBirthday(businessId: any) {
    // return this.http.post('/employee-manager/assign', payload)
    return this.http.get<any>(
      `${environment.apiBaseUrl}/employee-manager/team-member/birthday/${businessId}`
    )
  }

  changePassword(userId: string, payload: { oldPassword: string; newPassword: string }) {
    return this.http.put(`${this.apiUrl}/changePassword/${userId}`, payload)
  }

  getEmployeeChartData(params: string) {
    return this.http.get<any>(`${this.apiUrl}/chart?${params}`)
  }
  getEmployeeStatusChartData() {
    return this.http.get<any>(`${this.apiUrl}/status-chart`)
  }

  getCelebrations(options?: {
    month?: boolean
    page?: number
    limit?: number
    search?: string
    type?: 'birthday' | 'anniversary'
  }) {
    let params: any = {}

    if (options?.month) params.month = true
    if (options?.page) params.page = options.page
    if (options?.limit) params.limit = options.limit
    if (options?.search) params.search = options.search
    if (options?.type) params.type = options.type

    return this.http.get(`${this.apiUrl}/celebrations`, { params })
  }
  getFiveEmployees(): Observable<User[]> {
    return this.http.get<User[]>(`${this.apiUrl}/five-employees`)
  }

  getUserPermissions() {
    return this.http.get<Record<string, string[]>>(`${this.apiUrl}/permissions`)
  }

  // getCurrentSubscription() {
  //   return this.http.get<any>(`${this.apiUrl}/current-subscription`)
  // }

  getCurrentSubscription(businessId: string) {
    return this.http.get<any>(`${this.apiUrl}/current-subscription`, {
      params: {
        businessId
      }
    })
  }
}
